import { DashboardState } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import chatbotEvents from "../../../shared/utility/chatbot-events";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import { subscribeHelpdeskEvents } from "../helpdesk/helpdesk-events";
import { HelpdeskModal } from "./helpdesk-modal";
import "./helpdesk-button.scss";

export interface IHelpdeskButtonState {
  isModalOpen: boolean;
}

export interface IHelpdeskButtonProps {}

class HelpdeskButton extends PureSdComponent<IHelpdeskButtonProps & IWithSDProps, IHelpdeskButtonState> {
  constructor(props: IHelpdeskButtonProps & IWithSDProps) {
    super(props);
    this.state = {
      isModalOpen: false
    };
  }

  private unsubscribeHelpdeskEvents: (() => void) | null = null;

  componentDidMount(): void {
    this.props.sd.getTicketNotifyCount();
    // Kuika ITSM only (the stream is never opened for Zendesk): a support reply moves the badge
    // while the designer is open.
    this.unsubscribeHelpdeskEvents = subscribeHelpdeskEvents((): void => {
      this.props.sd.getTicketNotifyCount();
    });
  }

  componentWillUnmount(): void {
    this.unsubscribeHelpdeskEvents?.();
    this.unsubscribeHelpdeskEvents = null;
  }

  handleOpenModal = () => {
    this.setState({ isModalOpen: true });
    chatbotEvents.setChatbotVisibility(false);
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    // The full-page Helpdesk renders the same canvas this modal does, against the same state.
    // Letting the rail open the modal on top of it would mount two of everything — two ticket
    // loads, two of each test hook, and two file inputs where the reply upload expects one.
    if (this.props.sd.dashboardState === DashboardState.zendesk) {
      return null;
    }

    return (
      <>
        <KuikaButton
          data-testid="leftMenuHelpDeskTabButton"
          data-onboarding-id="left_menu_helpdesk"
          type="tertiary"
          size="md"
          isIcon
          color="neutral"
          active={this.state.isModalOpen}
          onClick={this.handleOpenModal}
          className="kuika-helpdesk-button"
        >
          <KuikaSvg name="help-square" type="sidebar-icons" width={18} height={18} pointer />
          {this.props.sd.ticketCount != "0" && (
            <span className="kuika-helpdesk-button__count">{this.props.sd.ticketCount}</span>
          )}
        </KuikaButton>
        {/*
          Mounted only while open. The panel is subscribed to the screen-design context, so a
          closed-but-mounted modal still re-rendered on every provider write in the designer —
          measured at ~2 renders per write — to produce no DOM at all, since KModal renders
          nothing when hidden.
        */}
        {this.state.isModalOpen && <HelpdeskModal isOpen onClose={this.handleCloseModal} />}
      </>
    );
  }

  /**
   * The unread count comes from the provider, and should appear whatever else the designer is
   * doing — including under the change reasons `shouldComponentUpdate` routes through here.
   */
  checkNeedRender = (): boolean => {
    return true;
  };
}

const helpdeskButton = withSD<IHelpdeskButtonProps>(HelpdeskButton);
export { helpdeskButton as HelpdeskButton };
